<template lang="html">
  <div class="succeed">
    <div class="banner">
      <img :src="succeed.app_banner" alt="">
    </div>
    <div class="content" :style="{height: scrollerHeight}">
      <img src="../../assets/image/pay/succeed.png" alt="" class="succeedImg">
      <p class="txt1">您已报名成功</p>
      <p v-html="succeed.tips"></p>
      <img :src="succeed.qrcode" alt="" class="code">
    </div>
  </div>
</template>

<script>
import {pagebase, pagehost} from '@/utils/http.js';
import WxShare from '@/utils/wxshare'

export default {
  computed: {
    scrollerHeight: function() {
      return (window.innerHeight - 155) + 'px';
    }
  },
  data() {
    return {
      succeed : [],
    };
  },
  mounted(){
    this.init();
    this.succeedData();
  },
  methods:{
    init(){
			new WxShare().share({
        title: '零经验7天入门硬件设计',
        desc: '电巢EMEA体验营',
        link: pagebase + '/#/emeaad',
        imgUrl: pagehost + '/images/common/logo.jpeg'
      })
		},
    succeedData(){
      this.$http({
        url: '/activity/Info',
        method: 'get',
        params: {
          activity_id : this.$route.query.activity_id,
        },
      }).then( (res) => {
        this.succeed = res.data;
      })
    },
  }
}
</script>

<style lang="css" scoped>
.banner{
  background-color: #D8D8D8;
}
.banner img{
  width: 100%;
  height: 16.5rem;
  object-fit: cover;
  z-index: 1;
}
.content{
  position: relative;
  border-radius: 1.5rem 1.5rem 0 0;
  margin-top: -1.5rem;
  z-index: 5;
  height: 100%;
  background-color: #FFF;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.succeedImg{
  margin-top: 1.5rem;
  width: 9rem;
}
.txt1{
  margin-top: 1rem;
  font-size: 1.8rem;
  font-weight: 600;
  color: #1D2023;
}
.txt2{
  margin-top: .5rem;
  font-size: 1.6rem;
  color: #3F454B;
}
.code{
  width: 16rem;
  margin-top: 2rem;
}
</style>
